import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() => ({
  root: {
    minWidth: '228px',
    width: '100%',
    maxWidth: '370px',
    height: 'min-content',
    '@media screen and (max-width: 1280px)': {
      width: '100%',
      maxWidth: '330px',
    },
    '@media screen and (max-width: 768px)': {
      width: '100%',
      maxWidth: '288px',
    },
    '& .hashteg': {
      color: '#13538E !important',
      marginRight: 10,
      fontFamily: ['\'Rubik\'', 'sans-serif'],
      fontStyle: 'normal',
      fontSize: '12px',
      fontWeight: '300',
      cursor: 'pointer',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
    boxShadow: '0px 0px 5px rgba(33, 33, 33, 0.2)',
    '-webkit-box-shadow': '0px 0px 5px 0px rgba(33,33,33,0.2)',
    '-moz-box-shadow': '0px 0px 5px 0px rgba(33,33,33,0.2)',
    borderRadius: '2px',
    '&:hover': {
      boxShadow: 'none',
    },
    '& .MuiCardContent-root': {
      padding: '0 !important',
    },
  },
  media: {
    height: 217,
    margin: 15,
    cursor: 'pointer',
  },
  hashtegBox: {
    display: 'flex',
    margin: '0px 16px 16px 16px',
    fontSize: 12,
  },
  dataAdress: {
    padding: '0px 16px 16px 16px',
    fontSize: 12,
    color: '#9B9B9B',
    fontFamily: ['\'Rubik\'', 'sans-serif'],
    fontStyle: 'normal',
    fontWeight: '300',
  },
  status: {
    fontSize: 12,
    color: '#E85A50',
    padding: '0px 16px 16px 16px',
  },
  cardTitle: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontFamily: ['\'Comic Neue\'', 'sans-serif'],
    fontStyle: 'normal',
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#373631',
    cursor: 'pointer',
    width: '100%',
  },
  subDescriptions: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontFamily: ['\'Rubik\'', 'sans-serif'],
    fontStyle: 'normal',
    fontSize: '16px',
    fontWeight: '300',
    color: '#373631',
    '& .read-more-button': {
      color: '#13538E !important',
      cursor: 'pointer',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  },
  clickContainer: {
    padding: '0 16px 16px 16px',
    cursor: 'pointer',
  },
}))
